import { jsx as _jsx } from "react/jsx-runtime";
import { DateFormatter, getLocalTimeZone, parseAbsolute, today } from "@internationalized/date";
import { useCurrentUser } from "@sprout/client-graphql";
import { useMemo } from "react";
import { useLocale } from "react-aria";
import { StarBorder as BaseStarBorder } from "sprout-ui-icons";
import { Flex, Text } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
import styled from "styled-components";
const InlineFlexWrapper = styled(Flex)`
  display: inline-flex;
  vertical-align: top;
`;
const StarBorder = styled(BaseStarBorder)`
  color: ${themeGet("colors.yellow.200")};
`;
const PostWhen = (props)=>{
    const currentUser = useCurrentUser();
    const { when  } = props;
    const { locale  } = useLocale();
    const { displayText , inThePast , isToday  } = useMemo(()=>{
        var ref;
        const timezone = (ref = currentUser === null || currentUser === void 0 ? void 0 : currentUser.timezone) !== null && ref !== void 0 ? ref : getLocalTimeZone();
        const dateValue = parseAbsolute(when, timezone);
        const currentDate = today(timezone);
        const within7Days = dateValue.compare(currentDate) >= 0 && dateValue.compare(currentDate.add({
            days: 7
        })) < 0;
        const notThisYear = dateValue.year > currentDate.year;
        return {
            // use `CalendarDate` so it doesn't take the time into account
            isToday: currentDate.compare(dateValue) === 0,
            inThePast: dateValue.compare(currentDate) < 0,
            displayText: new DateFormatter(locale, within7Days ? {
                weekday: "short"
            } : {
                day: "numeric",
                month: "short",
                year: notThisYear ? "numeric" : undefined
            }).format(new Date(when))
        };
    }, [
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.timezone,
        locale,
        when
    ]);
    return /*#__PURE__*/ _jsx(InlineFlexWrapper, {
        alignItems: "center",
        borderRadius: "8px",
        bg: isToday ? undefined : inThePast ? "#d2e3d5" : "grey.100",
        p: isToday ? undefined : 0,
        mr: 1,
        children: isToday ? /*#__PURE__*/ _jsx(StarBorder, {}) : /*#__PURE__*/ _jsx(Text, {
            as: "span",
            color: "black.60",
            fontSize: 1,
            children: displayText
        })
    });
};
export default PostWhen;
